module.exports = {
	"parent_site": "minutemedia",
	"parent_domain": "minutemedia.com",
	"master_site": "90min",
	"master_domain": "90min.com",
	"ftb90_site": "ftb90",
	"ftb90_domain": "ftb90.com",
	"old_site": "ftbpro",
	"old_domain": "ftbpro.com",
	"twelve_up_site": "12up",
	"twelve_up_domain": "12up.com",
	"indian_site": "ht_media",
	"indian_domain": "90min.in",
	"german_site": "german_site",
	"german_domain": "90min.de",
	"archway_site": "archway",
	"archway_domain": "minutemediabeta.com",
	"dbltap_site": "dbltap",
	"dbltap_domain": "dbltap.com",
	"ei_site": "ei",
	"ei_domain": "minutemedialpha.com",
	"floor8_site": "floor8",
	"floor8_domain": "floor8.com",
	"newsroom_domain": "minutemediaservices.com",
	"sites_and_domains": [
		{
			"site": "90min",
			"domain": "90min.com"
		},
		{
			"site": "ftb90",
			"domain": "ftb90.com"
		},
		{
			"site": "12up",
			"domain": "12up.com"
		},
		{
			"site": "ht_media",
			"domain": "90min.in"
		},
		{
			"site": "german_site",
			"domain": "90min.de"
		},
		{
			"site": "archway",
			"domain": "minutemediabeta.com"
		},
		{
			"site": "dbltap",
			"domain": "dbltap.com"
		},
		{
			"site": "ei",
			"domain": "minutemedialpha.com"
		},
		{
			"site": "floor8",
			"domain": "floor8.com"
		}
	],
	"domains_sites_map": {
		"90min.com": "90min",
		"ftb90.com": "ftb90",
		"12up.com": "12up",
		"90min.in": "ht_media",
		"90min.de": "german_site",
		"dbltap.com": "dbltap",
		"minutemediabeta.com": "archway",
		"minutemedialpha.co.uk": "ei",
		"minutemedialpha.com": "ei",
		"esporteinterativo.com.br": "ei",
		"floor8.com": "floor8"
	},
	"all_soccer_sites": [
		"90min",
		"ftb90",
		"ht_media",
		"german_site"
	],
	"sites_with_app": [
		"90min",
		"ftb90",
		"12up",
		"ht_media",
		"german_site",
		"ei"
	],
	"all_sites": [
		"90min",
		"ftb90",
		"12up",
		"ht_media",
		"german_site",
		"dbltap"
	],
	"system_supported_sites": [
		"90min",
		"ftb90",
		"12up",
		"ht_media",
		"german_site",
		"archway",
		"dbltap",
		"ei",
		"floor8"
	],
	"sites_without_primary_locales": [
		"90min",
		"12up",
		"ht_media",
		"german_site",
		"archway",
		"dbltap"
	],
	"sites_with_editorial_user": [
		"ftb90"
	],
	"primary_sites": [
		"90min",
		"12up",
		"dbltap"
	],
	"whitelabel_sites": [
		"ftb90"
	],
	"beta_sites": [
		"archway"
	]
};


//////////////////
// WEBPACK FOOTER
// ./config/sites.yml
// module id = 889
// module chunks = 0 1 2 3